export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export function moveToTheEnd<T = unknown>(array: Array<T>, x: number, y: number) {
  array.splice(y, 0, array.splice(x, 1)[0]);
  return array;
}
